import React from 'react'

import clsx from 'clsx'
import { Pagination } from 'swiper/modules'
import { Swiper, SwiperSlide } from 'swiper/react'

import PricingPlanCard from 'components/PricingPlanCard'
import { useListingDetailContext } from 'context/ListingDetailContext'

import { replacePricings } from './pricingDataReplace'
import TextBase from '../TextBase'

import classes from './Pricing.module.scss'

/* eslint-disable import/no-duplicates -- Swiper module CSS imports are side-effect imports. */
import 'swiper/css'
import 'swiper/css/pagination'
/* eslint-enable import/no-duplicates */

const SWIPER_BREAKPOINTS_CONFIG = {
  360: {
    slidesPerView: 1.2,
    centeredSlides: true,
    spaceBetween: 8,
  },
  600: {
    slidesPerView: 1.6,
    centeredSlides: false,
    spaceBetween: 16,
  },
  960: {
    slidesPerView: 2,
    centeredSlides: false,
    spaceBetween: 16,
  },
  1280: {
    slidesPerView: 3,
    centeredSlides: false,
    spaceBetween: 16,
  },
}

/** @type {import("./types").default} */
const Pricing = ({ className, title, htmlText }) => {
  const { listing } = useListingDetailContext()

  const htmlTextReplaced = replacePricings(htmlText, listing.pricing)

  return (
    <div className={clsx('Pricing', classes.root, className)}>
      <TextBase title={title} htmlText={htmlTextReplaced} />

      <Swiper
        modules={[Pagination]}
        pagination={{ clickable: true, el: '#cr-pricing-pagination' }}
        breakpoints={SWIPER_BREAKPOINTS_CONFIG}
      >
        {listing.pricing.plans.map((plan, index) => (
          <SwiperSlide key={`plan_${index}`}>
            <PricingPlanCard key={plan.name} listing={listing} currentPlan={plan} position={index} />
          </SwiperSlide>
        ))}
      </Swiper>

      <div id="cr-pricing-pagination" className={classes.pagination} />
    </div>
  )
}

export default Pricing
